/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents sensitive API keys for a business.
 * @export
 * @interface BulkToggleDevourIQResponse
 */
export interface BulkToggleDevourIQResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BulkToggleDevourIQResponse
     */
    dryRun: boolean;
    /**
     * 
     * @type {number}
     * @memberof BulkToggleDevourIQResponse
     */
    updatedCount: number;
}

/**
 * Check if a given object implements the BulkToggleDevourIQResponse interface.
 */
export function instanceOfBulkToggleDevourIQResponse(value: object): value is BulkToggleDevourIQResponse {
    if (!('dryRun' in value) || value['dryRun'] === undefined) return false;
    if (!('updatedCount' in value) || value['updatedCount'] === undefined) return false;
    return true;
}

export function BulkToggleDevourIQResponseFromJSON(json: any): BulkToggleDevourIQResponse {
    return BulkToggleDevourIQResponseFromJSONTyped(json, false);
}

export function BulkToggleDevourIQResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkToggleDevourIQResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dryRun': json['dryRun'],
        'updatedCount': json['updatedCount'],
    };
}

export function BulkToggleDevourIQResponseToJSON(json: any): BulkToggleDevourIQResponse {
    return BulkToggleDevourIQResponseToJSONTyped(json, false);
}

export function BulkToggleDevourIQResponseToJSONTyped(value?: BulkToggleDevourIQResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dryRun': value['dryRun'],
        'updatedCount': value['updatedCount'],
    };
}

